import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { StrategicRecommendation } from 'types'
import Styles from './DetailsDrawer.module.scss'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { useRootStore } from 'stores/RootStore'
import { EditDrawer } from '../EditDrawer/EditDrawer'
import { Pressable } from '@react-aria/interactions'

interface Props {
  recommendation: StrategicRecommendation
  brandKitId: number
}

export const Recommendation = ({ recommendation, brandKitId }: Props) => {
  const { drawersStore } = useRootStore()

  const openEditDrawer = () => {
    drawersStore.openDrawer(EditDrawer, { recommendation, brandKitId })
  }

  return (
    <Pressable onPress={openEditDrawer}>
      <div key={recommendation.id} className={Styles.recommendation}>
        <div className={Styles.recommendationHeader}>
          <Text variant="primary" color="var(--dark-90)">
            {recommendation.recommendation}
          </Text>
          <ChevronRightSmall size={20} color="var(--dark-25)" />
        </div>
        {Boolean(recommendation.reasoning) && (
          <div className={Styles.reasoning}>
            <Heading level={5}>Reasoning</Heading>
            <Text variant="secondary">{recommendation.reasoning}</Text>
          </div>
        )}
      </div>
    </Pressable>
  )
}
